import { createFileRoute } from '@tanstack/react-router';

import { queryClient } from '~app/query-client';

import { getAllClassesWithSearchOptions } from '~entities/classes/api/get-all-classes-with-search';
import { classListViewQueryOptions } from '~entities/studios/api/class-list-view';

import { ClassListPage } from '~features/classes/index';
import { defaultClassListSearchParams } from '~features/classes/ui/class-list-saved-view';

import { getStoredPageSize } from '~shared/helpers/page-size-preference';

export const Route = createFileRoute('/_auth/_layout/classes/')({
  component: ClassListPage,
  loader: async ({ preload }) => {
    // The studio default view decides the initial sort, so resolve it first
    const savedView = await queryClient
      .ensureQueryData(classListViewQueryOptions)
      .catch(() => null);

    // Preload the same query the table issues for a default-filter load
    const options = getAllClassesWithSearchOptions(
      defaultClassListSearchParams(savedView, getStoredPageSize(10)),
    );
    await queryClient.ensureQueryData(options);

    return {
      maxAge: preload ? 5 * 60 * 1000 : 0, // Preloaded data stays valid for 5 minutes
    };
  },
});
